var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-chatbot-wrapper font-sans" }, [
    _c(
      "aside",
      {
        ref: "dialog",
        staticClass:
          "dark:bg-gray-800 bg-gray-400 dark:bg-opacity-100 sm:bg-opacity-50 dark:text-white text-gray-800 h-full fixed sm:left-0 top-0 p-[24px] transition-all",
        class: _vm.openSidebar
          ? "left-0 w-[300px]"
          : "w-[300px] sm:w-[72px] -left-[300px]"
      },
      [
        _c(
          "button",
          {
            staticClass:
              "aside-button fixed sm:relative left-[24px] sm:left-auto",
            attrs: {
              type: "button",
              id: "aside-button",
              "aria-label": _vm.openSidebar
                ? "Collapse sidebar"
                : "Expand sidebar"
            },
            on: {
              click: function($event) {
                return _vm.toggleSidebar()
              }
            }
          },
          [
            !_vm.openSidebar
              ? _c(
                  "svg",
                  {
                    staticClass: "dark:fill-white fill-gray-800",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM3.75 5.25H7.5V18.75H3.75V5.25ZM20.25 18.75H9V5.25H20.25V18.75Z"
                      }
                    })
                  ]
                )
              : _c(
                  "svg",
                  {
                    staticClass: "dark:fill-white fill-gray-800",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M20.25 3.75H3.75C3.35218 3.75 2.97064 3.90804 2.68934 4.18934C2.40804 4.47064 2.25 4.85218 2.25 5.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V5.25C21.75 4.85218 21.592 4.47064 21.3107 4.18934C21.0294 3.90804 20.6478 3.75 20.25 3.75ZM20.25 18.75H8.25V5.25H20.25V18.75Z"
                      }
                    })
                  ]
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "mt-[48px] sm:mt-[24px] transition-all",
            class: _vm.openSidebar
              ? "opacity-100 h-auto visible delay-100"
              : "opacity-0 invisible h-0 delay-0"
          },
          [
            _vm.sidebarItems
              ? _c(
                  "ul",
                  {
                    staticClass:
                      "mt-[24px] text-[14px] leading-[20px] font-light flex flex-col gap-[28px]"
                  },
                  _vm._l(_vm.sidebarItems, function(anchor, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass:
                          "flex items-center gap-[8px] hover:opacity-70 transition-all"
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "dark:fill-light fill-gray-800",
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M18.75 6.89296C18.7186 7.98098 18.2712 9.01554 17.5 9.78359L14.7851 12.5C14.3897 12.8976 13.9194 13.2127 13.4013 13.4273C12.8833 13.6419 12.3279 13.7516 11.7671 13.75H11.7632C11.193 13.7496 10.6285 13.6349 10.1033 13.4127C9.5781 13.1905 9.10274 12.8653 8.70532 12.4563C8.3079 12.0473 7.99648 11.5628 7.78945 11.0314C7.58242 10.5 7.48399 9.93256 7.49996 9.3625C7.50462 9.19674 7.57494 9.03962 7.69545 8.9257C7.81595 8.81179 7.97678 8.75041 8.14254 8.75507C8.3083 8.75974 8.46542 8.83006 8.57933 8.95056C8.69324 9.07107 8.75462 9.23189 8.74996 9.39765C8.73858 9.80072 8.8081 10.202 8.95443 10.5777C9.10076 10.9535 9.32092 11.2961 9.6019 11.5853C9.88288 11.8745 10.219 12.1044 10.5903 12.2615C10.9617 12.4187 11.3608 12.4997 11.764 12.5C12.1604 12.501 12.5531 12.4234 12.9193 12.2718C13.2855 12.1201 13.618 11.8974 13.8976 11.6164L16.6125 8.90156C17.1726 8.33438 17.4856 7.56862 17.4831 6.77149C17.4806 5.97435 17.1628 5.21057 16.5991 4.6469C16.0355 4.08324 15.2717 3.76547 14.4746 3.76298C13.6774 3.76048 12.9117 4.07346 12.3445 4.63359L11.4851 5.49296C11.367 5.60523 11.2096 5.66689 11.0466 5.6648C10.8837 5.66272 10.7279 5.59705 10.6127 5.4818C10.4974 5.36654 10.4318 5.21083 10.4297 5.04785C10.4276 4.88488 10.4893 4.72753 10.6015 4.60937L11.4609 3.75C11.8574 3.35338 12.3281 3.03876 12.8462 2.8241C13.3643 2.60945 13.9196 2.49896 14.4804 2.49896C15.0412 2.49896 15.5965 2.60945 16.1146 2.8241C16.6327 3.03876 17.1035 3.35338 17.5 3.75C17.9106 4.16168 18.2332 4.65263 18.4481 5.19295C18.663 5.73328 18.7657 6.31169 18.75 6.89296ZM8.51558 14.5047L7.65621 15.3641C7.37591 15.6462 7.04233 15.8698 6.67484 16.0219C6.30735 16.174 5.9133 16.2515 5.51558 16.25C4.91894 16.2495 4.33583 16.0722 3.83993 15.7405C3.34403 15.4087 2.95758 14.9374 2.72942 14.3861C2.50126 13.8348 2.44163 13.2283 2.55806 12.6431C2.67449 12.0579 2.96175 11.5204 3.38355 11.0984L6.09371 8.38359C6.52057 7.95447 7.0666 7.66362 7.66089 7.54881C8.25517 7.434 8.87025 7.50054 9.42623 7.73978C9.98222 7.97903 10.4534 8.37992 10.7786 8.89039C11.1039 9.40087 11.2681 9.99734 11.25 10.6023C11.2453 10.7681 11.3067 10.9289 11.4206 11.0494C11.5345 11.1699 11.6916 11.2403 11.8574 11.2449C12.0231 11.2496 12.184 11.1882 12.3045 11.0743C12.425 10.9604 12.4953 10.8033 12.5 10.6375C12.515 10.0571 12.4119 9.47976 12.197 8.94043C11.9822 8.4011 11.6599 7.91104 11.25 7.5C10.4493 6.6997 9.36363 6.25013 8.2316 6.25013C7.09957 6.25013 6.01388 6.6997 5.21324 7.5L2.49996 10.2148C1.90326 10.8113 1.49677 11.5712 1.33184 12.3986C1.16691 13.226 1.25096 14.0838 1.57336 14.8634C1.89575 15.6431 2.44203 16.3097 3.14315 16.779C3.84428 17.2482 4.66878 17.4992 5.51246 17.5C6.07329 17.5016 6.62888 17.392 7.14705 17.1774C7.66523 16.9628 8.13569 16.6476 8.53121 16.25L9.39058 15.3906C9.49173 15.2715 9.54457 15.1188 9.53869 14.9626C9.53281 14.8064 9.46863 14.6581 9.35881 14.5469C9.24899 14.4357 9.10149 14.3697 8.94541 14.3619C8.78932 14.3541 8.63597 14.405 8.51558 14.5047Z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "dark:[&>*]:!text-white dark:!text-white text-gray-800 [&>*:hover]:!no-underline [&>*:hover]:text-white resources-item",
                          domProps: { innerHTML: _vm._s(anchor) }
                        })
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "nav",
          {
            staticClass:
              "absolute bottom-[24px] left-[24px] flex flex-col gap-[24px] dark:text-white font-light text-[14px] leading-[20px]"
          },
          [
            _c(
              "a",
              {
                staticClass:
                  "flex gap-[8px] items-center hover:opacity-70 transition-all hover:!no-underline hover:text-white",
                attrs: {
                  href: _vm.communityURL,
                  target: "_blank",
                  "aria-label": _vm.communityURL
                    ? "Go to community home page"
                    : "Community home page (link not available)"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dark:fill-white fill-gray-800 flex-shrink-0",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M20.5603 10.1887L13.0603 2.68875C12.779 2.40766 12.3977 2.24976 12 2.24976C11.6024 2.24976 11.221 2.40766 10.9397 2.68875L3.4397 10.1887C3.29973 10.3277 3.18878 10.493 3.1133 10.6752C3.03782 10.8574 2.99931 11.0528 3.00001 11.25V20.25C3.00001 20.4489 3.07903 20.6397 3.21968 20.7803C3.36033 20.921 3.5511 21 3.75001 21H9.75001C9.94892 21 10.1397 20.921 10.2803 20.7803C10.421 20.6397 10.5 20.4489 10.5 20.25V15H13.5V20.25C13.5 20.4489 13.579 20.6397 13.7197 20.7803C13.8603 20.921 14.0511 21 14.25 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25V11.25C21.0007 11.0528 20.9622 10.8574 20.8867 10.6752C20.8112 10.493 20.7003 10.3277 20.5603 10.1887ZM19.5 19.5H15V14.25C15 14.0511 14.921 13.8603 14.7803 13.7197C14.6397 13.579 14.4489 13.5 14.25 13.5H9.75001C9.5511 13.5 9.36033 13.579 9.21968 13.7197C9.07903 13.8603 9.00001 14.0511 9.00001 14.25V19.5H4.50001V11.25L12 3.75L19.5 11.25V19.5Z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.openSidebar
                  ? _c("span", { staticClass: "dark:text-white" }, [
                      _vm._v("\n          Home\n        ")
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "flex gap-[8px] items-center hover:opacity-70 transition-all whitespace-nowrap",
                attrs: {
                  type: "button",
                  "aria-label": _vm.isDark
                    ? "Switch to light mode"
                    : "Switch to dark mode"
                },
                on: {
                  click: function($event) {
                    return _vm.toggleTheme((_vm.isDark = !_vm.isDark))
                  }
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dark:fill-white fill-gray-800 flex-shrink-0",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M11.25 3.75V1.5C11.25 1.30109 11.329 1.11032 11.4697 0.96967C11.6103 0.829018 11.8011 0.75 12 0.75C12.1989 0.75 12.3897 0.829018 12.5303 0.96967C12.671 1.11032 12.75 1.30109 12.75 1.5V3.75C12.75 3.94891 12.671 4.13968 12.5303 4.28033C12.3897 4.42098 12.1989 4.5 12 4.5C11.8011 4.5 11.6103 4.42098 11.4697 4.28033C11.329 4.13968 11.25 3.94891 11.25 3.75ZM18 12C18 13.1867 17.6481 14.3467 16.9888 15.3334C16.3295 16.3201 15.3925 17.0892 14.2961 17.5433C13.1997 17.9974 11.9933 18.1162 10.8295 17.8847C9.66557 17.6532 8.59647 17.0818 7.75736 16.2426C6.91824 15.4035 6.3468 14.3344 6.11529 13.1705C5.88378 12.0067 6.0026 10.8003 6.45672 9.7039C6.91085 8.60754 7.67988 7.67047 8.66658 7.01118C9.65327 6.35189 10.8133 6 12 6C13.5908 6.00174 15.1159 6.63444 16.2407 7.75928C17.3656 8.88412 17.9983 10.4092 18 12ZM16.5 12C16.5 11.11 16.2361 10.24 15.7416 9.49993C15.2471 8.75991 14.5443 8.18314 13.7221 7.84254C12.8998 7.50195 11.995 7.41283 11.1221 7.58647C10.2492 7.7601 9.44736 8.18868 8.81802 8.81802C8.18868 9.44736 7.7601 10.2492 7.58647 11.1221C7.41283 11.995 7.50195 12.8998 7.84254 13.7221C8.18314 14.5443 8.75991 15.2471 9.49993 15.7416C10.24 16.2361 11.11 16.5 12 16.5C13.1931 16.4988 14.337 16.0243 15.1806 15.1806C16.0243 14.337 16.4988 13.1931 16.5 12ZM5.46938 6.53063C5.61011 6.67136 5.80098 6.75042 6 6.75042C6.19902 6.75042 6.38989 6.67136 6.53063 6.53063C6.67136 6.38989 6.75042 6.19902 6.75042 6C6.75042 5.80098 6.67136 5.61011 6.53063 5.46938L5.03062 3.96938C4.88989 3.82864 4.69902 3.74958 4.5 3.74958C4.30098 3.74958 4.11011 3.82864 3.96938 3.96938C3.82864 4.11011 3.74958 4.30098 3.74958 4.5C3.74958 4.69902 3.82864 4.88989 3.96938 5.03062L5.46938 6.53063ZM5.46938 17.4694L3.96938 18.9694C3.82864 19.1101 3.74958 19.301 3.74958 19.5C3.74958 19.699 3.82864 19.8899 3.96938 20.0306C4.11011 20.1714 4.30098 20.2504 4.5 20.2504C4.69902 20.2504 4.88989 20.1714 5.03062 20.0306L6.53063 18.5306C6.60031 18.4609 6.65558 18.3782 6.6933 18.2872C6.73101 18.1961 6.75042 18.0985 6.75042 18C6.75042 17.9015 6.73101 17.8039 6.6933 17.7128C6.65558 17.6218 6.60031 17.5391 6.53063 17.4694C6.46094 17.3997 6.37822 17.3444 6.28717 17.3067C6.19613 17.269 6.09855 17.2496 6 17.2496C5.90145 17.2496 5.80387 17.269 5.71283 17.3067C5.62178 17.3444 5.53906 17.3997 5.46938 17.4694ZM18 6.75C18.0985 6.75008 18.1961 6.73074 18.2871 6.6931C18.3782 6.65546 18.4609 6.60025 18.5306 6.53063L20.0306 5.03062C20.1714 4.88989 20.2504 4.69902 20.2504 4.5C20.2504 4.30098 20.1714 4.11011 20.0306 3.96938C19.8899 3.82864 19.699 3.74958 19.5 3.74958C19.301 3.74958 19.1101 3.82864 18.9694 3.96938L17.4694 5.46938C17.3644 5.57427 17.2928 5.70796 17.2639 5.85352C17.2349 5.99908 17.2497 6.14998 17.3065 6.28709C17.3633 6.42421 17.4596 6.54139 17.583 6.62379C17.7065 6.70619 17.8516 6.75012 18 6.75ZM18.5306 17.4694C18.3899 17.3286 18.199 17.2496 18 17.2496C17.801 17.2496 17.6101 17.3286 17.4694 17.4694C17.3286 17.6101 17.2496 17.801 17.2496 18C17.2496 18.199 17.3286 18.3899 17.4694 18.5306L18.9694 20.0306C19.0391 20.1003 19.1218 20.1556 19.2128 20.1933C19.3039 20.231 19.4015 20.2504 19.5 20.2504C19.5985 20.2504 19.6961 20.231 19.7872 20.1933C19.8782 20.1556 19.9609 20.1003 20.0306 20.0306C20.1003 19.9609 20.1556 19.8782 20.1933 19.7872C20.231 19.6961 20.2504 19.5985 20.2504 19.5C20.2504 19.4015 20.231 19.3039 20.1933 19.2128C20.1556 19.1218 20.1003 19.0391 20.0306 18.9694L18.5306 17.4694ZM4.5 12C4.5 11.8011 4.42098 11.6103 4.28033 11.4697C4.13968 11.329 3.94891 11.25 3.75 11.25H1.5C1.30109 11.25 1.11032 11.329 0.96967 11.4697C0.829018 11.6103 0.75 11.8011 0.75 12C0.75 12.1989 0.829018 12.3897 0.96967 12.5303C1.11032 12.671 1.30109 12.75 1.5 12.75H3.75C3.94891 12.75 4.13968 12.671 4.28033 12.5303C4.42098 12.3897 4.5 12.1989 4.5 12ZM12 19.5C11.8011 19.5 11.6103 19.579 11.4697 19.7197C11.329 19.8603 11.25 20.0511 11.25 20.25V22.5C11.25 22.6989 11.329 22.8897 11.4697 23.0303C11.6103 23.171 11.8011 23.25 12 23.25C12.1989 23.25 12.3897 23.171 12.5303 23.0303C12.671 22.8897 12.75 22.6989 12.75 22.5V20.25C12.75 20.0511 12.671 19.8603 12.5303 19.7197C12.3897 19.579 12.1989 19.5 12 19.5ZM22.5 11.25H20.25C20.0511 11.25 19.8603 11.329 19.7197 11.4697C19.579 11.6103 19.5 11.8011 19.5 12C19.5 12.1989 19.579 12.3897 19.7197 12.5303C19.8603 12.671 20.0511 12.75 20.25 12.75H22.5C22.6989 12.75 22.8897 12.671 23.0303 12.5303C23.171 12.3897 23.25 12.1989 23.25 12C23.25 11.8011 23.171 11.6103 23.0303 11.4697C22.8897 11.329 22.6989 11.25 22.5 11.25Z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.openSidebar
                  ? _c("span", [
                      _vm.isDark
                        ? _c("span", [_vm._v("Light")])
                        : _c("span", [_vm._v("Dark")]),
                      _vm._v("\n          Mode\n        ")
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "flex gap-[8px] items-center hover:opacity-70 transition-all hover:!no-underline hover:text-white",
                attrs: {
                  href: _vm.communityURL,
                  target: "_blank",
                  "aria-label": _vm.communityURL
                    ? "Get help and support"
                    : "Help and support (link not available)"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "dark:fill-white fill-gray-800 flex-shrink-0",
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7805 17.9784C11.5623 17.935 11.3618 17.8278 11.2045 17.6705C11.0472 17.5132 10.94 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9606 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875ZM12 6.75C9.93188 6.75 8.25 8.26406 8.25 10.125V10.5C8.25 10.6989 8.32902 10.8897 8.46967 11.0303C8.61033 11.171 8.80109 11.25 9 11.25C9.19892 11.25 9.38968 11.171 9.53033 11.0303C9.67099 10.8897 9.75 10.6989 9.75 10.5V10.125C9.75 9.09375 10.7597 8.25 12 8.25C13.2403 8.25 14.25 9.09375 14.25 10.125C14.25 11.1562 13.2403 12 12 12C11.8011 12 11.6103 12.079 11.4697 12.2197C11.329 12.3603 11.25 12.5511 11.25 12.75V13.5C11.25 13.6989 11.329 13.8897 11.4697 14.0303C11.6103 14.171 11.8011 14.25 12 14.25C12.1989 14.25 12.3897 14.171 12.5303 14.0303C12.671 13.8897 12.75 13.6989 12.75 13.5V13.4325C14.46 13.1184 15.75 11.7544 15.75 10.125C15.75 8.26406 14.0681 6.75 12 6.75ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7661 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.openSidebar
                  ? _c("span", { staticClass: "dark:text-white" }, [
                      _vm._v("\n          Help\n        ")
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "h-100 chatbot-container",
        class: {
          "app-bar": _vm.showAppBar,
          "show-sidebar": _vm.isDialogVisible,
          "pl-0 sm:!pl-[300px]": _vm.openSidebar,
          "pl-0 sm:!pl-[72px]": !_vm.openSidebar
        }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "w-[24px] h-[24px] top-[24px] right-[24px] sm:w-[64px] sm:h-[64px] fixed sm:top-[28px] sm:right-[28px] overflow-hidden rounded-full"
          },
          [
            _c("div", {
              ref: "announcement",
              staticClass: "sr-only",
              attrs: { "aria-live": "assertive" }
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.communityURL,
                  target: "_blank",
                  "aria-label": _vm.communityURL
                    ? "Go to " +
                      (_vm.community.content && _vm.community.content.parameter2
                        ? _vm.community.content.parameter2
                        : "community") +
                      " home page"
                    : "Community logo (link not available)"
                }
              },
              [
                _vm.iconURL
                  ? _c("img", {
                      ref: "logoImage",
                      staticClass: "top-logo custom-logo",
                      attrs: {
                        src: _vm.iconURL,
                        alt:
                          _vm.community.content &&
                          _vm.community.content.parameter2
                            ? _vm.community.content.parameter2
                            : "Community Logo"
                      },
                      on: { load: _vm.fadeIn }
                    })
                  : _vm._e()
              ]
            )
          ]
        ),
        _vm._v(" "),
        this.isShowChatbot
          ? [
              _vm.loaded
                ? _c("iframe", {
                    ref: "botIframe",
                    staticClass: "chatbot-iframe min-h-full",
                    style: _vm.iframe.style,
                    attrs: {
                      src: _vm.iframe.src,
                      id: "botkit_client",
                      title:
                        (_vm.community.content &&
                        _vm.community.content.parameter2
                          ? _vm.community.content.parameter2
                          : "Chatbot") + " conversation interface",
                      frameborder: "0"
                    }
                  })
                : _vm._e()
            ]
          : _vm._e(),
        _vm._v(" "),
        this.isSubmitForm &&
        !this.unsubscribe &&
        !this.spamEmail &&
        !this.invalidMember
          ? [
              _c(
                "div",
                {
                  staticClass:
                    "header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation mt-30"
                },
                [
                  _c(
                    "h1",
                    { staticClass: "box-heading thankyou-template-title" },
                    [_vm._v("Fabulous!")]
                  ),
                  _vm._v(" "),
                  _vm.community.content &&
                  _vm.community.content.requestPageThankYou
                    ? _c("div", {
                        staticClass:
                          "box-sub-heading text-left content-textleft thankyou-custom-content",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.community.content.requestPageThankYou
                          )
                        }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "box-sub-heading text-left content-textleft thankyou-custom-content"
                        },
                        [
                          _vm._v(
                            "We will now recruit the right experts to help you."
                          )
                        ]
                      )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        this.unsubscribe && this.isSubmitForm ? [_vm._m(0)] : _vm._e(),
        _vm._v(" "),
        this.spamEmail && this.isSubmitForm ? [_vm._m(1)] : _vm._e(),
        _vm._v(" "),
        this.invalidMember && this.isSubmitForm
          ? [
              _c(
                "div",
                {
                  staticClass:
                    "header-text common-space-from-logo text-left unsubscribepage-thankumsg mt-30 chatbot-invalid-member"
                },
                [
                  _c(
                    "h1",
                    { staticClass: "box-heading thankyou-template-title" },
                    [_vm._v("Ooops. We’re really sorry.")]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "box-sub-heading thankyou-custom-content text-left content-textleft chatbot-custom-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.finalInvalidMemberMessage)
                    }
                  })
                ]
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "header-text common-space-from-logo text-center unsubscribepage-thankumsg mt-30"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "box-sub-heading thankyou-custom-content content-textleft text-warning"
          },
          [_vm._v("Your email address has been unsubscribed.")]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "header-text common-space-from-logo text-center unsubscribepage-thankumsg mt-30"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "box-sub-heading thankyou-custom-content content-textleft spam-email"
          },
          [_vm._v("Your email address has been blocked.")]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d50e3ed0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d50e3ed0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommunityChatbotRequestPage.vue
// module id = null
// module chunks = 